import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';

import JsBarcode from 'jsbarcode';
import { UsersContractResDto } from 'types/swagger';
import { VoucherDocument } from 'components/Icons/VoucherDocument';
import { VoucherLogo } from 'components/Icons/VoucherLogo';
import { VoucherUser } from 'components/Icons/VoucherUser';

export type VoucherPdfProps = {
  userData: UsersContractResDto;
  dataRichiesta: string;
  importo: string;
  voucherID: string;
  idTransazione: string;
  scadenza?: string;
};

export const VoucherPdf = ({
  userData,
  dataRichiesta,
  importo,
  voucherID,
  scadenza,
  idTransazione,
}: VoucherPdfProps) => {
  const cli_nome =
    userData.nome + ' ' + userData.cognome || '____________________________________________________________';
  const cli_codiceContratto = userData.codiceContratto || '_______________________________';

  let canvas;
  canvas = document.createElement('canvas');
  JsBarcode(canvas, idTransazione, { displayValue: false, height: 150 });
  const barcode = canvas.toDataURL();

  Font.register({ family: 'Helvetica', src: './Helvetica.ttf' });
  Font.register({ family: 'Helvetica-Bold', src: './Helvetica-Bold.ttf' });
  const styles = StyleSheet.create({
    section: {
      width: 400,
      padding: '20px 5vw',
      fontSize: '11pt',
      lineHeight: '1.1pt',
    },
    sectionHeader: { fontFamily: 'Helvetica-Bold', fontWeight: 'bold', color: '#303E47' },
    heading: {
      margin: '0 0 30px 0',
      paddingBottom: '30px',
      borderBottom: '1px solid black',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    title: {
      fontFamily: 'Helvetica-Bold',
      fontWeight: 'bold',
      textAlign: 'right',
      width: '40%',
    },
    paragraph: {
      fontFamily: 'Helvetica',
      textAlign: 'justify',
      width: '60%',
      marginBottom: '30px',
    },
    labelBold: { fontFamily: 'Helvetica-Bold', fontWeight: 'bold' },
    label: { fontFamily: 'Helvetica' },
    labelIconBlock: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' },
  });

  return (
    <Document>
      <Page size="A4" style={styles.section}>
        <View style={styles.heading}>
          <VoucherLogo />
          <View style={styles.title}>
            <Text>Snaitech S.p.a</Text>
            <Text>Piazza della Repubblica 32, 20124 Milano</Text>
          </View>
        </View>
        <View>
          <Text style={styles.paragraph}>
            Gentile Cliente di seguito i dettagli del prelievo richiesto. Stampa il tuo voucher e presentalo presso il
            tuo Punto SNAI.
          </Text>

          <View style={styles.labelIconBlock}>
            <VoucherUser />
            <Text style={styles.sectionHeader}>DATI UTENTE</Text>
          </View>

          <View
            style={{
              border: '5px solid black',
              display: 'flex',
              flexDirection: 'row',
              padding: '20px',
              marginBottom: '30px',
            }}
          >
            <View
              style={{
                width: '50%',
                borderRight: '1px solid #303E47',
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
              }}
            >
              <View>
                <Text style={styles.labelBold}>NOME</Text>
                <Text style={styles.label}>{cli_nome}</Text>
              </View>
              <View>
                <Text style={styles.labelBold}>N.CONTO DI GIOCO</Text>
                <Text style={styles.label}>{cli_codiceContratto}</Text>
              </View>
            </View>
            <View style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <View>
                <Text style={styles.labelBold}>DATA RICHIESTA</Text>
                <Text style={styles.label}>{dataRichiesta}</Text>
              </View>
              <View>
                <Text style={styles.labelBold}>IMPORTO DA PRELEVARE</Text>
                <Text style={styles.label}>{importo}</Text>
              </View>
            </View>
          </View>

          <View style={styles.labelIconBlock}>
            <VoucherDocument />
            <Text style={styles.sectionHeader}>IL TUO VOUCHER</Text>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: '#303E47',
              height: '150px',
            }}
          >
            <View style={{ width: '40%', margin: '5px 0 5px 5px', backgroundColor: 'white' }}>
              <View style={{ margin: '15px 0 15px 15px' }}>
                <Text style={styles.labelBold}>DA UTILIZZARE ENTRO</Text>
                <Text style={styles.label}>{scadenza}</Text>
              </View>
            </View>
            <View
              style={{
                marginLeft: '20px',
                width: '60%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '15px 15px 15px 0',
              }}
            >
              <Text style={{ color: 'white', fontSize: '36px' }}>{voucherID}</Text>
            </View>
          </View>
          <View style={{ marginTop: '70px' }}>
            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <View>
                <Text>________________________________</Text>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Text style={{ fontSize: '8px', ...styles.labelBold }}>TIPO DOCUMENTO</Text>
                  <Text style={{ fontSize: '6px', color: 'gray', ...styles.label }}>compilazione punto vendita</Text>
                </View>
              </View>
              <View style={{ marginLeft: 'auto' }}>
                <Text>______________________________________________________</Text>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Text style={{ fontSize: '8px', ...styles.labelBold }}>NUMERO DOCUMENTO</Text>
                  <Text style={{ fontSize: '6px', color: 'gray', ...styles.label }}>compilazione punto vendita</Text>
                </View>
              </View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '50px' }}>
              <View>
                <Text>________________________________</Text>
                <Text style={{ fontSize: '8px', ...styles.labelBold }}>DATA</Text>
              </View>
              <View>
                <Text>________________________________</Text>
                <Text style={{ fontSize: '8px', ...styles.labelBold }}>FIRMA</Text>
              </View>
            </View>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '74px',
              borderBottom: '2px solid black',
            }}
          >
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <Image src={barcode} style={{ width: '38%', paddingBottom: '5px' }} />
          </View>
        </View>
      </Page>
    </Document>
  );
};
